import { selectData } from "fe-shared/utils/reducerUtils";

import {
  STATE_COMMUNICATION_CONFIG,
  STATE_COMMUNICATION_CONFIG_DATA,
  STATE_COMMUNICATION_CONFIG_WEBCHAT_KEY,
  STATE_COMMUNICATION_CONFIG_ORIGIN,
  STATE_COMMUNICATION_CONFIG_IS_DEBUGGER_MODE,
} from "./default";

export const getCommunicationConfig = state =>
  selectData(state, STATE_COMMUNICATION_CONFIG);
export const getCommunicationConfigData = state =>
  selectData(getCommunicationConfig(state), STATE_COMMUNICATION_CONFIG_DATA);
export const getCommunicationConfigDataWebchatKey = state =>
  selectData(
    getCommunicationConfigData(state),
    STATE_COMMUNICATION_CONFIG_WEBCHAT_KEY,
    ""
  );
export const getCommunicationConfigDataOrigin = state =>
  selectData(
    getCommunicationConfigData(state),
    STATE_COMMUNICATION_CONFIG_ORIGIN,
    ""
  );
export const getCommunicationConfigDataIsDebuggerMode = state =>
  selectData(
    getCommunicationConfigData(state),
    STATE_COMMUNICATION_CONFIG_IS_DEBUGGER_MODE,
    ""
  );
